import { Link, useLocation } from 'react-router-dom';

export const IndividualReportUnavailable = () => {
  const location = useLocation();
  const isrReturnTo = (location.state as { isrReturnTo?: string } | null)?.isrReturnTo;
  const returnTo = isrReturnTo?.startsWith('/') && !isrReturnTo.startsWith('//') ? isrReturnTo : null;

  return (
    <div className="tw-flex tw-justify-center tw-py-12">
      <div
        className="tw-w-[85%] tw-max-w-3xl tw-rounded-3xl tw-border tw-border-solid tw-border-neutral-300 tw-bg-white tw-p-8"
        role="status"
      >
        <h1 className="tw-mb-3 tw-font-sora tw-text-2xl tw-font-semibold tw-text-neutral-950">
          Individual Student Report unavailable
        </h1>
        <p className="tw-mb-6 tw-font-atkinson tw-text-base tw-text-neutral-700">
          This student does not have a valid assigned Roadmap. Please select a valid Roadmap for them from the{' '}
          <Link className="tw-text-blue-700 tw-underline" to="/students">
            Students page
          </Link>
          , or reach out to our{' '}
          <a
            className="tw-text-blue-700 tw-underline"
            href="https://newclassrooms.atlassian.net/servicedesk/customer/portal/76"
            rel="noreferrer"
            target="_blank"
          >
            Help Center.
          </a>
        </p>
        <Link className="tw-font-atkinson tw-font-bold tw-text-blue-700 tw-underline" to={returnTo ?? '/progress'}>
          {returnTo ? 'Back to previous page' : 'Back to Progress'}
        </Link>
      </div>
    </div>
  );
};
